let parsed = {};

try {
    parsed = JSON.parse(process.env.REACT_APP_EUNSA_KEYCLOAK_JSON_URL);
} catch (e) {
    parsed = {};
}

export const keycloakClientId = parsed.clientId || parsed.resource || '';

let keycloakInstance = null;

export const setKeycloakInstance = instance => {
    keycloakInstance = instance;
};

export const keycloakLogoutUrl = () => {
    const base = `${process.env.REACT_APP_EUNSA_KEYCLOAK_URL}/realms/isss/protocol/openid-connect/logout`;
    const redirect = encodeURIComponent(process.env.REACT_APP_EUNSA_FRONTEND_URL);
    const idToken = keycloakInstance && keycloakInstance.idToken;

    return `${base}?redirect_uri=${redirect}&post_logout_redirect_uri=${redirect}`
        + (keycloakClientId ? `&client_id=${encodeURIComponent(keycloakClientId)}` : '')
        + (idToken ? `&id_token_hint=${encodeURIComponent(idToken)}` : '');
};



// WEBPACK FOOTER //
// ./src/util/keycloakClient.js